import React from "react";
import { Field } from "formik";

import FormSelect from "../../FormSelect";
import { useAdminProviderDataContext } from "../../../../context";

const QuantityOptions = (): React.ReactElement => {
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  return (
    <Field
      //data-test="quantity-value"
      variant="standard"
      name="qty"
      label="Quantity"
      placeholder="Quantity"
      component={FormSelect}
      enableReinitialize
      disabled={!allowed_features.quantity_create_codes}
      options={[
        { id: 1, label: "Zero times", value: 0 },
        { id: 11, label: "Single use", value: 1 },
        ...[2, 3, 4, 5, 6, 7, 8, 9].map((i) => ({
          id: i,
          label: `${i} times`,
          value: i,
        })),
        { id: 10, label: "Unlimited", value: -1 },
      ]}
    />
  );
};

export default QuantityOptions;
